import { render, staticRenderFns } from "./CollectionLayoutTiles.vue?vue&type=template&id=634dd805&lang=pug&"
import script from "./CollectionLayoutTiles.vue?vue&type=script&lang=js&"
export * from "./CollectionLayoutTiles.vue?vue&type=script&lang=js&"
import style0 from "./CollectionLayoutTiles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('634dd805')) {
      api.createRecord('634dd805', component.options)
    } else {
      api.reload('634dd805', component.options)
    }
    module.hot.accept("./CollectionLayoutTiles.vue?vue&type=template&id=634dd805&lang=pug&", function () {
      api.rerender('634dd805', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/CollectionLayoutTiles.vue"
export default component.exports